import { render, staticRenderFns } from "./UserKeyHoldingsTab.vue?vue&type=template&id=6a636164&"
import script from "./UserKeyHoldingsTab.vue?vue&type=script&lang=ts&"
export * from "./UserKeyHoldingsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports